import { ResolveFn } from '@angular/router';
import { AppState } from '../../store/app.reducers';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import * as SalesActions from '@zayan-erp/stores';
import * as HomeBuildingActions from '@zayan-erp/stores';

export const publicPagesResolver: ResolveFn<void> = () => {
  const store = inject(Store<AppState>);
  store.dispatch(SalesActions.loadSalesOfficesPublic());
  store.dispatch(HomeBuildingActions.loadCountries());
};
